import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import JoiningPageData from 'app/MoDels/Content/JoiningPageData';

import React from 'react';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';

export default class JoiningPage extends Page<JoiningPageData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div
        className='JoiningPage'
        {...getBackgroundImageProps(isMobile ? this.props.data?.mobileBackgroundImage : this.props.data?.backgroundImage, context)}>
        <h1 className='JoiningPage__description'>{this.props.data.title.value}</h1>

        <ContentArea noWrap data={mainContentArea} context={context} />
      </div>
    );
  }
}
